/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */


import { JsonLdItem } from '@/store/types';

/**
 * Utility service that provides general static methods.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class Utils {
    /**
     * Version getter.
     * @return {string}
     */
    public static getVersion(): string {
        return '2.9.1';
    }

    /**
     * Async timeout function.
     * @param {number} ms
     * @return {Promise<void>}
     */
    public static timeout(ms: number = 500): Promise<void> {
        return new Promise((resolve: any): number => window.setTimeout(resolve, ms));
    }

    /**
     * @param {string} uuid
     * @return {boolean}
     */
    public static isUuid4(uuid: string): boolean {
        const reg: RegExp = /[0-9a-fA-F]{8}-?[0-9a-fA-F]{4}-?4[0-9a-fA-F]{3}-?[89abAB][0-9a-fA-F]{3}-?[0-9a-fA-F]{12}$/;
        return (uuid.length > 0) && reg.test(uuid);
    }

    /**
     * Production mode checker.
     * @return {boolean}
     */
    public static isProduction(): boolean {
        return 'production' === process.env.NODE_ENV;
    }

    /**
     * Extract the uuid from a JsonLd item id.
     * @param {JsonLdItem} item
     * @return {string}
     */
    public static extractJsonLdItemUuid(item: JsonLdItem): string {
        if (!item['@id']) {
            return '';
        }

        return Utils.extractIriUuid(item['@id']);
    }

    /**
     * Extract the uuid from a IRI id.
     * @param {string | JsonLdItem} itemId
     * @return {string}
     */
    public static extractIriUuid(itemId: string | JsonLdItem): string {
        let uuid: string = (typeof itemId === 'string') ? itemId : '';
        if (typeof itemId !== 'string' && !!itemId['@id']) {
            uuid = itemId['@id'];
        }

        const reg: RegExp =
            /^.*([0-9a-fA-F]{8}-?[0-9a-fA-F]{4}-?4[0-9a-fA-F]{3}-?[89abAB][0-9a-fA-F]{3}-?[0-9a-fA-F]{12})$/;
        return uuid.replace(reg, '$1');
    }

    /**
     * Extract the id from a IRI id.
     * @param {string} itemId
     * @return {string}
     */
    public static extractIriId(itemId: string): string {
        const reg: RegExp = /^.*[\\/]([^\\/]+)$/;
        return itemId.replace(reg, '$1');
    }

}





